import { useQuery } from "react-query";
import {
  apiGetSetting,
  CANDIDATE_ALLOWED_ATTACHMENT_EXTENSIONS,
} from "../../../../../api/setting/apiGetSetting";
import {
  ExtractFnReturnType,
  QueryConfig,
} from "../../../../../lib/react-query";
import { parseAllowedExtensions } from "../util/candidateAttachment.util";
import { candidateAttachmentKeys } from "./candidateAttachments.query-keys";

const HTTP_NOT_FOUND = 404;
const ALLOWED_EXTENSIONS_STALE_TIME_MS = 5 * 60 * 1000;

/**
 * Extensions accepted on upload. A setting that does not exist (404) allows
 * none, as in the backend.
 */
export const apiGetAllowedAttachmentExtensions = async (): Promise<
  string[]
> => {
  try {
    const setting = await apiGetSetting(CANDIDATE_ALLOWED_ATTACHMENT_EXTENSIONS);

    return parseAllowedExtensions(setting.value);
  } catch (e: any) {
    if (e?.response?.status === HTTP_NOT_FOUND) {
      return [];
    }

    throw e;
  }
};

type QueryFnType = typeof apiGetAllowedAttachmentExtensions;

type TUseAllowedAttachmentExtensionsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useAllowedAttachmentExtensions = ({
  config,
}: TUseAllowedAttachmentExtensionsOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    staleTime: ALLOWED_EXTENSIONS_STALE_TIME_MS,
    ...config,
    queryKey: candidateAttachmentKeys.allowedExtensions,
    queryFn: apiGetAllowedAttachmentExtensions,
  });
};
